import { createContext } from 'react';

import { noop } from '@blockpulse3/data/shared';
import { CompanyDraftContent } from '@blockpulse3/graphql/hooks';

import { companyDraftContentDefaultValues } from './schema';

export type ISPVFormContext = {
  /* ** Draft id ** */
  draftId: string;
  /* ** Data for each step ** */
  companyDraftContent: CompanyDraftContent;
  /* ** Setters for each step ** */
  setCompanyDraftContent: React.Dispatch<React.SetStateAction<CompanyDraftContent>>;
};

/* ** Use schema default values from each forms ** */
export const initCompanyDraftContent: ISPVFormContext['companyDraftContent'] =
  companyDraftContentDefaultValues;

export const SPVFormContext = createContext<ISPVFormContext>({
  draftId: '',
  companyDraftContent: initCompanyDraftContent,
  setCompanyDraftContent: () => noop,
});
